import { Component } from '@angular/core';
import { environment } from '@environment/environment';

@Component({
  selector: 'app-sidebar-version',
  template: `
    <code class="h-min w-full min-w-0 truncate pl-1 text-sm text-nowrap">
      Version {{ appVersion }}
    </code>
  `,
})
export class SidebarVersionComponent {
  /** PROPERTIES **/
  /** Application version from environment **/
  protected readonly appVersion = environment.appVersion;
}
